<template>
    <b-button
        :class="{'w-100': isW100, 'h-11 border-0 bg-main hover:bg-hoverMain focus:ring-0 font-bold': isTwMainBtn, 'h-11 border-0 bg-denyColor hover:bg-hoverDenyColor focus:ring-0 font-bold': isTwDenyBtn}"
        :type="type"
        :variant="variant"
        :title="$t(title)"
        :size="size"
        :disabled="isDisabled"
        v-b-tooltip.hover
        v-bind="attributes"
        @click="doAction"
    >
        <slot/>
    </b-button>
</template>

<script>
export default {
    name: "ButtonTag",
    props: {
        type: {
            type: String,
            default: "button",
            validator: (value) => ['button', 'submit', 'link'].indexOf(value) !== -1,
        },
        variant: {
            type: String,
            default: "",
            // validator: (value) => ['danger', 'info', 'primary', 'success', 'light', 'outline-primary'].indexOf(value) !== -1,
        },
        title: {
            type: String,
            default: "",
        },
        url: {
            type: String,
            default: undefined
        },
        size: {
            type: String,
            default: "xl",
            validator: (value) => ['xs', 'sm', 'md', 'lg', 'xl'].indexOf(value) !== -1,
        },
        doAction: {
            type: Function,
            default: function () {
            }
        },
        isW100: {
            type: Boolean,
            default: true,
        },
        isDisabled: {
            type: Boolean,
            default: false
        },
        isTwMainBtn: {
            type: Boolean,
            default: false
        },
        isTwDenyBtn: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        attributes() {
            let result = {}

            if (this.url !== undefined) {
                result.to = this.$i18nHelper.getUrl(this.url)
            }

            return result
        },
    },
}
</script>
